import { Box } from '@mui/material';
import { Navigate, Outlet } from 'react-router';
import { selectOptionalUser } from 'features/auth/store/authSelectors';
import { useReportLoading } from 'features/loading';
import { logger } from 'features/logger/logger';
import { RoutePath } from 'features/routing/constants';
import { useAppSelector } from 'features/store/hooks';
import { useSetUrlLocale } from './useSetUrlLocale';

export const ProtectedAdminRoutes = () => {
  const user = useAppSelector(selectOptionalUser);
  const localeInitialized = useSetUrlLocale();

  useReportLoading(!user || !localeInitialized);

  if (!user) {
    logger.debug('ProtectedAdminRoutes wrapper, user is not signed in');
    return null;
  }
  if (!localeInitialized) return null;

  if (user.role !== 'admin') {
    logger.debug('ProtectedAdminRoutes wrapper, user is not an admin');
    return <Navigate to={RoutePath.StudyChoice} replace />;
  }

  // Admin tools sit on a plain page colour, not the body's stripes.
  return (
    <Box
      component="main"
      sx={{ height: '100%', bgcolor: 'background.default' }}
    >
      <Outlet />
    </Box>
  );
};
